import { useLocation } from "react-router-dom";
import { parse } from "query-string";
import { QuestionQuery } from "../../api/questions/typings";

export function useQueryParamsEnhanced() {
	const listOfArrayedParams = ["filter[number]", "filter[difficulty]"];
	const listOfArrayedParamsWithId = ["filter[skills]", "filter[topics]"];
	const location = useLocation();
	const params = parse(location.search, {
		arrayFormat: "index",
	}) as QuestionQuery;
	const enhancedParams: Record<string, any> = {};

	for (let key in params) {
		if (listOfArrayedParams.includes(key) && !Array.isArray(params[key])) {
			enhancedParams[key] = params[key] ? (params[key]! as unknown as string).split(",") : undefined;
		} else if (listOfArrayedParamsWithId.includes(key)) {
			if (Array.isArray(params[key])) {
				enhancedParams[`${key}[]`] = params[key];
			} else {
				enhancedParams[`${key}[]`] = params[key] ? (params[key]! as unknown as string).split(",") : undefined;
			}
		} else {
			enhancedParams[key] = params[key];
		}
	}

	return enhancedParams;
}
